// src/features/works/WorksModule.jsx
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import WorksList from './WorksList';
import WorkForm from './WorkForm';
import WorkProfile from './WorkProfile';
import { useNavigationHistory } from '../../hooks/useNavigationHistory';

/**
 * Módulo de Obras
 * Maneja las rutas y componentes para el módulo de Obras
 */
function WorksModule() {
   // Inicializar el hook personalizado
   const { goBack } = useNavigationHistory();
  return (
    <Routes>
      {/* Ruta base: muestra la lista de obras */}
      <Route index element={<WorksList goBack={goBack}/>} />
      
      {/* Ruta para crear nueva obra */}
      <Route path="add" element={<WorkForm goBack={goBack}/>} />
      
      {/* Ruta para editar una obra existente */}
      <Route path=":id/edit" element={<WorkForm goBack={goBack}/>} />
      
      {/* Ruta para ver perfil de obra */}
      <Route path=":id" element={<WorkProfile goBack={goBack}/>} />
    </Routes>
  );
}

export default WorksModule;